import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HomeService } from '../home.service';
import { Subscription } from 'rxjs';
import { MsgCenterService } from '../navbar/msg-center/msg-center.service';
import { Router, NavigationEnd } from '@angular/router';
import { SocketService } from '../socket.service';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { IconsService } from '../shared/icons.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedsService } from 'src/app/shareds/shareds.service';
import { WebNotificationService } from '../../../web-notification.service';
import { TitleService } from '../../../title.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  screenWidth: number;
  disengageWindows: any;
  menuItems = [];
  dashboardPrefix = environment.dashboardPrefix;
  subscription: Subscription;
  menutabSubscription: Subscription;
  sideBarWidth = '270px';
  userName = null;
  userType = null;
  img_src: any;
  menutab: any;
  getVersion: any;
  appAgentHandover = false;
  setActive = false;
  translatorLanguage: any;

  conversationtab = {
    name: 'Conversations',
    path: '/Conversations',
    label: null,
    icon: 'conversations.png',
    status: true,
    font_icon: 'far fa-comment-alt',
    sub: [
      {
        name: 'Live Agents',
        path: '/liveagents',
        label: null,
        icon: 'overview.png',
        status: true,
        sub: null,
        font_icon: '',
      },
      {
        name: 'Live Feed',
        path: '/Conversations',
        label: null,
        icon: 'overview.png',
        status: true,
        sub: null,
        font_icon: '',
      },
      {
        name: 'History',
        path: '/history',
        label: null,
        icon: 'overview.png',
        status: true,
        sub: null,
        font_icon: '',
      },
      {
        name: 'Flow Responses',
        path: '/flow-responses',
        label: null,
        icon: 'overview.png',
        status: true,
        sub: null,
        font_icon: '',
      },
    ],
  };
  presentUrl: string;
  readCount: any;
  user_id: any;
  constructor(
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly homeService: HomeService,
    private readonly msgCenterService: MsgCenterService,
    private readonly iconsService: IconsService,
    private readonly socket: SocketService,
    private readonly translate: TranslateService,
    private readonly sharedService: SharedsService,
    private readonly titleService: TitleService,
    private readonly webNotification: WebNotificationService,
  ) {
    this.translatorLanguage = localStorage.getItem('Language');
    this.translate.setDefaultLang('en');
    this.setVersion();
    translate.use(this.translatorLanguage ? this.translatorLanguage : 'en');
    this.subscription = this.homeService.getMessage().subscribe((data) => {
      this.handleMessageType(data);
    });
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const res = event.url.split('/');
        this.presentUrl = res[2];
        if (
          res[2] === 'flow-builderv2' ||
          res[2] === 'flow-builderv3' ||
          res[2] === 'richmenu' ||
          res[2] === 'flex'
        ) {
          this.setActive = true;
        } else {
          this.setActive = false;
        }
        this.setActiveSubMenu();
      });

    const r = this.router.url.split('/');
    if (r[1] === 'flow-builderv2' || r[1] === 'flow-builderv3') {
      this.setActive = true;
    } else {
      this.setActive = false;
    }
  }
  handleMessageType(data) {
    if (data.type === 'sideBar') {
      this.sideBarWidth = this.setValue(data.message, '270px', '70px');
    }
    if (data.type === 'profile') {
      this.img_src = localStorage.getItem('companyNameLogoUrl')
        ? JSON.parse(localStorage.getItem('companyNameLogoUrl'))
        : '';
    }
    if (data.type === 'menutab') {
      this.handleMenutab();
    }
  }
  handleMenutab() {
    const userData = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    this.menutab = localStorage.getItem('menutab')
      ? JSON.parse(localStorage.getItem('menutab'))
      : '';
    if (this.menutab) {
      this.menuItems = this.menutab;
    } else if (userData?.roles?.menu_tab) {
      this.menuItems = userData.roles.menu_tab;
    } else {
      this.menuItems = [];
    }
    this.appAgentHandover =
      userData?.appSettings?.conversations?.agent_handover ?? false;

    if (this.appAgentHandover) {
      this.conversationtab.path = '/liveagents';
      const index = this.menuItems?.findIndex(
        (item) => item.name === 'Conversations',
      );
      this.conversationtab = this.setMenubarLabel(
        this.menuItems,
        this.conversationtab,
      );
      if (index > -1) {
        this.menuItems.splice(index, 1);
        this.menuItems.splice(index, 0, this.conversationtab);
      }
    }
    const conversationIndex = this.menuItems.findIndex(
      (item) => item?.name === 'Conversations',
    );

    if (conversationIndex !== -1) {
      const conversationItem = this.menuItems[conversationIndex];

      // Ensure submenu exists
      if (!conversationItem.sub) {
        conversationItem.sub = [];
      }

      // Find "Live Agents" inside "Conversations" submenu
      this.checkLiveagentIndex(conversationItem);
    }
  }
  // only on submenu
  menuToggle() {
    if (this.screenWidth < 750) {
      this.msgCenterService.toggleMenuSize(false);
    }
  }

  mainMenuCickToggle(menu) {
    if (!this.homeService.handleTrialExpiry()) {
      return;
    }
    if (this.screenWidth < 750 && menu?.sub && menu.sub.length > 1) {
      this.msgCenterService.toggleMenuSize(true);
    } else if (
      this.screenWidth < 750 &&
      ((menu?.sub && menu.sub.length < 1) || menu.sub == null) &&
      this.sideBarWidth === '270px'
    ) {
      this.msgCenterService.toggleMenuSize(false);
    }
  }

  ngOnInit() {
    this.user_id = JSON.parse(localStorage.getItem('user')).user_id;
    this.getUnreadNotification();
    this.subscription = this.socket.getMessage().subscribe((message) => {
      this.getUnreadNotification();
      this.getSocket(message);
    });
    this.homeService.readNotification.subscribe((value) => {
      this.getUnreadNotification();
    });
    this.disengageWindows = document.getElementsByName('disengageWindows');
    const userData = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    this.sharedService.getCompanyUrl().subscribe((result) => {
      this.img_src = result?.info?.url ?? './assets/img/uib-blue.png';
    });
    this.menutab = localStorage.getItem('menutab')
      ? JSON.parse(localStorage.getItem('menutab'))
      : '';
    this.menuItems =
      this.menutab && this.menutab !== ''
        ? this.menutab
        : userData.roles.menu_tab;
    this.appAgentHandover = userData.appSettings.conversations.agent_handover
      ? userData.appSettings.conversations.agent_handover
      : false;
    if (this.appAgentHandover) {
      this.conversationtab.path = '/liveagents';
      const index = this.menuItems.findIndex(
        (item) => item.name === 'Conversations',
      );
      this.conversationtab = this.setMenubarLabel(
        this.menuItems,
        this.conversationtab,
      );
      if (index > -1) {
        this.menuItems.splice(index, 1);
        this.menuItems.splice(index, 0, this.conversationtab);
      }
    }
    const conversationIndex = this.menuItems.findIndex(
      (item) => item.name === 'Conversations',
    );
    if (conversationIndex !== -1) {
      const conversationItem = this.menuItems[conversationIndex];
      if (!conversationItem.sub) {
        conversationItem.sub = [];
      }
      this.checkLiveagentIndex(conversationItem);
    }
    this.userName = userData.user_name;
    this.userType = userData.user_type;
    this.screenWidth = window.innerWidth;
    this.initResponsiveElements();
    this.homeService.handleTrialExpiry();
  }

  getSocket(message: any) {
    const fullUrl = this.router.url.split('?')[0];
    const path = fullUrl?.startsWith('/') ? fullUrl?.slice(1) : fullUrl;
    if (
      message.action !== 'chat-disengage' &&
      message.action !== 'chat-engage' &&
      message.action !== 'chat-reassign' &&
      (this.user_id === message.engage_enabled?.engager_id ||
        message.engage_enabled?.engager_id === null)
    ) {
      let type = '';
      if (message.engage_enabled?.engager_id) {
        type = 'active';
      } else if (message.engageRequest) {
        type = 'queue';
      }
      const isAgentIdMatching = (agentId, loginId) => {
        if (agentId) {
          if (Array.isArray(agentId)) {
            return agentId.includes(loginId);
          } else if (typeof agentId === 'string') {
            // if agentId is a string, check direct equality
            return agentId === loginId;
          }
        } else {
          if (!agentId && message.engage_enabled?.engagerId === loginId) {
            return true;
          } else if (!agentId && !message.engage_enabled?.engagerId) {
            return true;
          } else if (!agentId && !message.agentChat) {
            return true;
          }
        }
        // handle unexpected types
        return false;
      };
      let agent_id = null;
      if (Array.isArray(message.agent_id)) {
        if (message.agent_id.length > 0) {
          agent_id = message.agent_id;
        } else {
          agent_id = null;
        }
      } else if (typeof message.agent_id === 'string') {
        if (message.agent_id) {
          agent_id = message.agent_id;
        } else {
          agent_id = null;
        }
      }
      const result = isAgentIdMatching(agent_id, this.user_id);
      if (result && path !== 'dashboard/liveagents') {
        this.webNotification.showNotification(message, type);
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // Logout function
  logout(): void {
    if (
      this.homeService.agentOnlineStatus &&
      this.homeService.agentOnlineStatus.messagelength > 0
    ) {
      this.toastr.error(this.disengageWindows[0].innerText);
      this.router.navigate([environment.dashboardPrefix + '/liveagents']);
    } else {
      // Delete all items in local storage
      localStorage.clear();
      this.msgCenterService.logout().subscribe((response) => {});
      this.socket.disconnect();
      // Go to login page
      this.router.navigate([environment.dashboardPrefix + '/login']);
    }
  }

  initResponsiveElements() {
    this.screenWidth = window.screen.width;
  }

  getMenuIcon(name) {
    return this.iconsService.getMenuIcon(name);
  }

  setMenubarLabel(menuItems, conversationtab) {
    menuItems.forEach(function (item) {
      if (item.name === 'Conversations') {
        conversationtab.label = item.label ? item.label : null;
      }
      if (item.name === 'Conversations' && item.sub.length) {
        item.sub.forEach(function (subitem) {
          conversationtab.sub.map(function (tab) {
            if (tab.name === subitem.name) {
              tab.label = subitem.label ? subitem.label : null;
            }
          });
        });
      }
    });
    return conversationtab;
  }
  setValue(cond, val1, val2) {
    if (cond) {
      return val1;
    } else {
      return val2;
    }
  }
  setVersion() {
    this.sharedService.setVersion().subscribe((res: any) => {
      this.getVersion = res.version;
    });
  }
  setActiveSubMenu() {
    this.menuItems?.map((item) => {
      item.sub?.map((res) => {
        if (
          (res.name === 'Guided Flows' && this.presentUrl === 'guidedflows') ||
          (res.name === 'Rich menu' && this.presentUrl === 'richmenu') ||
          (res.name === 'Line Flex' && this.presentUrl === 'flex')
        ) {
          res.setActive = true;
        } else {
          res.setActive = false;
        }
      });
    });
  }
  checkLiveagentIndex(conversationItem) {
    const liveAgentIndex = conversationItem.sub.findIndex(
      (subItem) => subItem.path === '/liveagents',
    );

    if (this.appAgentHandover) {
      // If toggle is ON, ensure "Live Agents" exists
      if (liveAgentIndex === -1) {
        conversationItem.sub.unshift({
          name: 'Live Agents',
          path: '/liveagents',
          label: null,
          icon: 'overview.png',
          status: true,
          sub: null,
          font_icon: '',
        });
      }
    } else {
      if (liveAgentIndex !== -1) {
        conversationItem.sub.splice(liveAgentIndex, 1);
      }
    }
  }

  getUnreadNotification() {
    const arg = {
      agent_id: this.user_id,
    };
    this.homeService.getUnreadNotification(arg).subscribe({
      next: (data) => {
        if (data.info) {
          this.readCount = data.info?.count ?? 0;
          this.titleService.updateMessageCount(this.readCount);
        }
      },
      error: (err) => {
        console.error('Error listPlan:', err);
      },
    });
  }
}
